import {  Inbox, LucideIcon, UsersRound, MessageCircle, Navigation, SectionIcon, AppWindow, AlignVerticalDistributeEnd, UserCircle2Icon } from "lucide-react";


interface SidebarItem {
    title: string;
    href: string;
    icon: LucideIcon;
    children?: SidebarItem[]
}

export const adminRouts: SidebarItem[] = [
    {
        title: "Dashboard",
        href: "/admin/dashboard",
        icon: Inbox,
    },
    {
        title: "Admin Users",
        href: "/admin/users",
        icon: UsersRound,
    },
    {
        title: "Job Applications",
        href: "/admin/job-applications",
        icon: AppWindow,
    },
    {
        title: "Messages",
        href: "/admin/messages",
        icon: MessageCircle,
    },
    {
        title: "Academic Qualifications",
        href: "/admin/academic-qualifications",
        icon: AlignVerticalDistributeEnd,
    },
    {
        title: "Departments",
        href: "/admin/application-departments",
        icon: SectionIcon,
    },
    {
        title: "Nationalities",
        href: "/admin/nationalities",
        icon: Navigation,
    },
    {
        title: "Trainees",
        href: "/admin/trainees",
        icon: UserCircle2Icon,
    },

];

export type { SidebarItem }